'use client';
import { motion } from 'framer-motion';
import { CwitnesscardmodalBackdrop } from './CwitnesscardmodalBackdrop';
import { CwitnesscardmodalSurface } from './CwitnesscardmodalSurface';
import type { CwitnesscardmodalProps } from './Cwitnesscardmodal.types';
import { CWITNESSCARDMODAL_OVERLAY_STYLE, getCwitnesscardmodalWrapperStyle, } from './cwitnesscardmodalStyles';
import { useCwitnesscardmodalEffects } from './useCwitnesscardmodalEffects';
import { useCwitnesscardmodalLayout } from './useCwitnesscardmodalLayout';
export type { CwitnesscardmodalProps };
export function Cwitnesscardmodal({ card, layoutId, onClose, }: CwitnesscardmodalProps) {
    const { isMobile, vh } = useCwitnesscardmodalLayout();
    useCwitnesscardmodalEffects(onClose);
    return <div data-el="Cwitnesscardmodal/Root" style={CWITNESSCARDMODAL_OVERLAY_STYLE}>
            <CwitnesscardmodalBackdrop onClose={onClose}/>
            <motion.div data-el="Cwitnesscardmodal/MorphLayer" layoutId={layoutId} style={getCwitnesscardmodalWrapperStyle({ isMobile, vh })}>
                <CwitnesscardmodalSurface card={card} isMobile={isMobile} onClose={onClose}/>
            </motion.div>
        </div>
        ;
}
